export const theme = {
  colors: {
    buttonPrimaryBg: '#366EFF',
    buttonPrimaryBgRGB: '54, 110, 255',
    colorWhite: '#fff',
  },
}
